import { render } from "./MigracionActivosBRP.vue?vue&type=template&id=1f613a08"
import script from "./MigracionActivosBRP.vue?vue&type=script&lang=js"
export * from "./MigracionActivosBRP.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__